// extracted by mini-css-extract-plugin
export var sliderRange = "_nj-2";
export var sliderRoot = "_nj-0";
export var sliderThumb = "_nj-3";
export var sliderTrack = "_nj-1";